export default __webpack_public_path__ + "static/media/43.22117758.jpeg";